const NAME = 'BvConfig';
const PROP_NAME = '$bvConfig';
const DEFAULT_BREAKPOINT = ['xs', 'sm', 'md', 'lg', 'xl'];

export { DEFAULT_BREAKPOINT, NAME, PROP_NAME };
